module.exports = __webpack_public_path__ + "static/img/mingf16.bbb9171a.png";